import React, { useState } from "react"
import { Button, Modal } from "react-bootstrap"

// A single "Guide" button + modal that briefly explains each part of the
// certificate form. Keeping the guidance here (rather than as per-field text)
// keeps the form itself uncluttered and its two columns aligned.
const CertificateGuide = ({ currency }): JSX.Element => {
  const [show, setShow] = useState(false)

  const sections = [
    {
      title: "Certificate categories",
      body: "General Liability is selected by default. Select all additional coverage categories shown on the certificate. Any required coverage categories that are not selected will continue to display as incomplete. If the certificate includes multiple policies with different policy numbers, limits, insurers, or other coverage details, please upload the certificate separately for each coverage type and enter the corresponding policy information to ensure all details are captured accurately.",
    },
    {
      title: `Minimum Coverage (${currency})`,
      body: "Enter the total per-occurrence limit for the selected coverage type. If coverage is extended by an Excess or Umbrella policy, include those limits in the total amount entered to reflect the full coverage available for this category.",
    },
    {
      title: "Deductible",
      body: "Enter the deductible amount as listed on the certificate.",
    },
    {
      title: "Currency Code",
      body: "Enter the currency associated with the certificate limit(s).",
    },
    {
      title: "Expiration Date",
      body: "This field must be updated from the default value. The expiration date must be accurate, as the system will automatically expire the certificate on this date, and the certificate upload will become non-compliant.",
    },
    {
      title: "Jurisdiction",
      body: "Enter the jurisdiction as shown on the certificate and/or policy.",
    },
    {
      title: "Additional Guidance",
      body: "All information entered must be accurate and match the details shown on the certificate and/or policy. If any of the information above is not shown on the certificate, please verify the information with your insurance broker before submitting.",
    },
  ]

  return (
    <>
      <Button variant="outline-primary" size="sm" onClick={() => setShow(true)}>
        <i className="fas fa-info-circle me-2" />
        Guide
      </Button>

      <Modal show={show} onHide={() => setShow(false)} centered aria-labelledby="certificate-guide">
        <Modal.Header>
          <Modal.Title className="w-100" id="certificate-guide">
            <div className="d-flex justify-content-between">
              <span>Filling in your certificate</span>
              <span className="cursor-pointer" onClick={() => setShow(false)}>
                <i className="fas fa-times" />
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <dl className="mb-0">
            {sections.map((section) => (
              <React.Fragment key={section.title}>
                <dt>{section.title}</dt>
                <dd className="text-muted">{section.body}</dd>
              </React.Fragment>
            ))}
          </dl>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CertificateGuide
